/**
 * Shared toast.
 *
 * Mirrors the toast that already lives in account-subscriptions-inline.liquid
 * (same markup/classes) so it looks identical, but is available anywhere the
 * cart drawer is rendered — i.e. every page.
 *
 * Usage: window.kenckoToast('info' | 'success' | 'error', title, message)
 */
(function () {
  var TYPES = {
    success: { bg: 'rgb(var(--color-green-light, 209 250 229))', border: 'rgb(var(--color-green, 34 197 94))', icon: 'rgb(var(--color-green, 34 197 94))' },
    error:   { bg: 'rgb(var(--color-red-light, 254 226 226))',   border: 'rgb(var(--color-red, 239 68 68))',    icon: 'rgb(var(--color-red, 239 68 68))' },
    info:    { bg: '#ffffff',                                     border: 'rgba(0, 0, 0, 0.12)',                 icon: 'rgb(var(--color-foreground, 27 58 27))' }
  };

  function iconFor(type, color) {
    if (type === 'success') {
      return '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><circle cx="10" cy="10" r="10" fill="' + color + '" opacity="0.15"/><path d="M6 10l3 3 5-5" stroke="' + color + '" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    }
    return '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><circle cx="10" cy="10" r="10" fill="' + color + '" opacity="0.15"/><path d="M10 6v5M10 14h.01" stroke="' + color + '" stroke-width="1.8" stroke-linecap="round"/></svg>';
  }

  function showToast(type, title, message) {
    var existing = document.getElementById('kencko-toast');
    if (existing) existing.remove();

    var theme = TYPES[type] || TYPES.info;

    var toast = document.createElement('div');
    toast.id = 'kencko-toast';
    toast.setAttribute('role', 'status');
    toast.style.background = theme.bg;
    toast.style.borderColor = theme.border;
    toast.innerHTML =
      '<div class="kencko-toast__icon">' + iconFor(type, theme.icon) + '</div>' +
      '<div class="kencko-toast__body">' +
        (title ? '<p class="style-p4 kencko-toast__title"></p>' : '') +
        '<p class="style-p5 kencko-toast__message"></p>' +
      '</div>' +
      '<button id="kencko-toast-close" class="kencko-toast__close" aria-label="Close">&#x2715;</button>';

    if (title) toast.querySelector('.kencko-toast__title').textContent = title;
    toast.querySelector('.kencko-toast__message').textContent = message || '';

    document.body.appendChild(toast);
    toast.querySelector('#kencko-toast-close').addEventListener('click', function () { toast.remove(); });
    setTimeout(function () { if (toast.isConnected) toast.remove(); }, 6000);
  }

  window.kenckoToast = showToast;
  // Account pages define their own kenckoShowToast; only fill the gap elsewhere.
  if (!window.kenckoShowToast) window.kenckoShowToast = showToast;
})();
